import { User } from 'oidc-client';

export default function isAuthenticated(user?: User): boolean {
    if(user) {
        if (user.access_token && !user.expired) {
            return true;
        }
    }
    return false;
}